// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1gMEL","toolTip":"Title_toolTip__221UQ","button":"Title_button__agmf9"};